<template>
<div>
  <div class="Orders">
    <div class="select">
      <el-date-picker v-if="isshow" v-model="date" type="month" placeholder="选择年月" format="yyyy-MM" value-format="yyyy-MM" :clearable="false"></el-date-picker>
      <el-select
        v-if="isshow"
        @change="getSelected"
        v-model="value"
        multiple
        filterable
        allow-create
        default-first-option
        placeholder="查看单元编号" style="width:660px">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <router-link style="color:red;margin-left:6px;" tag="a" v-else :to="{path: `/navigator/property/${commonService.houserz}`}">申请开通线上查询物业费</router-link>
    </div>
  </div>
  <div id="subOutputRank-print">
    <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>总计金额：{{zrow}}</span>
      <span style="margin-left:30px;color:#D0011B;font-size:18px;">
        <el-tooltip class="item" effect="dark" content="当前园区两年内的总欠费（含当月）" placement="top-start">
          <span>总欠费金额：{{qirow}}</span>
        </el-tooltip>
      </span>
      <el-button style="float: right; padding: 3px 0" type="text" @click="setItem2()">打印汇总通知单</el-button>
    </div>
  </el-card>
  <el-card class="box-card" v-for="(item, index) in list" :key="index">
    <div slot="header" class="clearfix">
      <span>单元编号: {{index}}</span>
      <el-button style="float: right; padding: 3px 0" type="text" @click="setItem(index)">打印</el-button>
    </div>
    <el-table :data="item" border show-summary :summary-method="getSummaries" style="max-width: 100%;" size="mini">
      <el-table-column prop="ReceivedDate" label="月份" :formatter="doFormatDate"></el-table-column>
      <el-table-column prop="UnitCode" label="单元编号"></el-table-column>
      <el-table-column prop="Area" label="收费面积"></el-table-column>
      <el-table-column prop="ChargingItem" label="收费项目"></el-table-column>
      <el-table-column prop="Periods" label="费用属期"></el-table-column>
      <el-table-column prop="UnitPrice" label="单价"></el-table-column>
      <el-table-column prop="AccountReceivable" label="应收金额"></el-table-column>
      <el-table-column prop="ReceivedMoney" label="已收金额"></el-table-column>
      <el-table-column prop="Arrears" label="欠收金额"></el-table-column>
    </el-table>
  </el-card>
  </div>

  <div id="PrintContent" style="margin:0 auto;width:900px;font-size:12px; display: none;">
    <div class="divTitle" style="font-size:28px; font-weight:bold; text-decoration:underline; text-align:center;">深圳天安智慧园区运营有限公司数码管理处</div>
    <div class="divTitle" style="font-size:28px; font-weight:bold; text-decoration:underline; text-align:center;"><span v-if="this.total>0">交款通知单</span><span v-else>交款通知单<span style="color:red">(补打)</span></span></div>
    <!-- <img class="gongz" width="300" src="@/assets/homePage/666.png" alt=""> -->
    <table width="100%" cellpadding="0" style="margin-top:5px;">
      <colgroup>
        <col width="50px">
        <col width="280px">
        <col width="50px">
        <col width="220px">
        <col width="100px">
        <col width="150px">
      </colgroup>
      <tbody>
      <tr>
        <td style="font-size:12px;">单元</td>
        <td colspan="3" style="font-size:12px;">{{buildName}}</td>
        <td style="font-size:12px;">制单日期：</td>
        <td style="font-size:12px;">{{new Date().toLocaleDateString()}}</td>
      </tr>
      <tr>
        <td style="font-size:12px;">客户</td>
        <td style="font-size:12px;">{{userName}}</td>
        <td style="font-size:12px;">账号：</td>
        <td style="font-size:12px;">-</td>
        <td style="font-size:12px;">收费面积：</td>
        <td style="font-size:12px;">{{area}}平方米</td>
      </tr>
      </tbody>
    </table>
    <table cellspacing="0" class="tablelist" width="100%">
      <colgroup>
        <col width="120">
        <col width="100">
        <col width="100">
        <col width="100">
        <col width="100">
        <col width="160">
        <col width="120">
        <col width="200">
      </colgroup>
      <thead>
      <tr>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">收费项目</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">收费单元</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">所属日期</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">上次读数</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">本次读数</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">净用量</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">单价</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">金额</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="(row,i) in this.item" :key="i">
          <td style="font-size:12px;">{{row.ChargingItem}}</td>
          <td style="font-size:12px;">{{row.UnitCode}}</td>
          <td style="font-size:12px;">{{row.Periods}}</td>
          <td style="font-size:12px;">{{splitUtilty(row.Utilities, '-', 1)}}</td>
          <td style="font-size:12px;">{{splitUtilty(row.Utilities, '-', 0)}}</td>
          <td style="font-size:12px;">{{splitUtilty(row.Utilities, '-', 2)}}</td>
          <td style="font-size:12px;">{{row.Utilities?splitUtilty(row.Utilities, '-', 3):row.UnitPrice}}</td>
          <td style="font-size:12px;">{{total>0?row.Arrears:row.ReceivedMoney}} </td>
        </tr>
      </tbody>
      <tfoot>
      <tr>
        <th colspan="2" style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">合计人民币(大写):</th>
        <th colspan="5" style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">{{this.total>0?this.totalCnTw:this.butottw}}</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">￥:{{this.total>0?this.total:this.butot}}元</th>
      </tr>
      </tfoot>
    </table>
    <div>
      <span style="font-size:12px;">说明：{{remark}}</span>
      <br />
      <br/>
      <span v-html="commonService.remaks" style="font-size:12px;">
            <!-- 1、居民水费:22吨以内2.67元/吨,23-30吨4.01元/吨,31吨以上8.01元/吨,商业用水3.35元/吨,工业用水3.35元/吨<br />
            2、居民污水处理费:22吨以内用量×0.9×0.9元/吨,23-30吨用量×0.9×1.00元/吨,31吨以上用量×0.9×1.10元/吨。垃圾处理费：用量×0.9×0.59元/吨<br />
            3、商业污水处理费:水量×0.9×1.2元,工业污水处理费,水量×0.9×1.05元,垃圾处理费:污水量×0.9×0.27元<br />
            4、当月24日起，逾期每日加收管理费0.5‰,垃圾处理费3‰,电费1‰,水费1％的滞纳金,计算以交费当日金额为准<br />
            5、缴费查询请电：天安数码城管理处:83458333；转账支付费用的，请在摘要栏注明楼栋，公司名称及单元号信息。 -->
           </span>
    </div>
  </div>
  <div id="ZContent" style="margin:0 auto;width:900px;font-size:12px; display: none;">
    <div class="divTitle" style="font-size:28px; font-weight:bold; text-decoration:underline; text-align:center;">深圳天安智慧园区运营有限公司数码管理处</div>
    <div class="divTitle" style="font-size:28px; font-weight:bold; text-decoration:underline; text-align:center;"><span v-if="this.total>0">交款通知单</span><span v-else>交款通知单<span style="color:red">(补打)</span></span></div>
    <table width="100%" cellpadding="0" style="margin-top:5px;">
      <colgroup>
        <col width="50px">
        <col width="280px">
        <col width="50px">
        <col width="220px">
        <col width="100px">
        <col width="150px">
      </colgroup>
      <tbody>
      <tr>
        <td style="font-size:12px;">单元</td>
        <td colspan="3" style="font-size:12px;">{{buildName}}</td>
        <td style="font-size:12px;">制单日期：</td>
        <td style="font-size:12px;">{{new Date().toLocaleDateString()}}</td>
      </tr>
      <tr>
        <td style="font-size:12px;">客户</td>
        <td style="font-size:12px;">{{userName}}</td>
        <td style="font-size:12px;">账号：</td>
        <td style="font-size:12px;">-</td>
        <td style="font-size:12px;">收费面积：</td>
        <td style="font-size:12px;">{{area}}平方米</td>
      </tr>
      </tbody>
    </table>
    <table cellspacing="0" class="tablelist" width="100%">
      <colgroup>
        <col width="120">
        <col width="100">
        <col width="100">
        <col width="100">
        <col width="100">
        <col width="160">
        <col width="120">
        <col width="200">
      </colgroup>
      <thead>
      <tr>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">收费项目</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">收费单元</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">所属日期</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">上次读数</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">本次读数</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">净用量</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">单价</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">金额</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="(row,i) in this.item" :key="i">
          <td style="font-size:12px;">{{row.ChargingItem}}</td>
          <td style="font-size:12px;">{{row.UnitCode}}</td>
          <td style="font-size:12px;">{{row.Periods}}</td>
          <td style="font-size:12px;">{{splitUtilty(row.Utilities, '-', 1)}}</td>
          <td style="font-size:12px;">{{splitUtilty(row.Utilities, '-', 0)}}</td>
          <td style="font-size:12px;">{{splitUtilty(row.Utilities, '-', 2)}}</td>
          <td style="font-size:12px;">{{row.Utilities?splitUtilty(row.Utilities, '-', 3):row.UnitPrice}}</td>
          <!-- <td style="font-size:12px;">{{row.AccountReceivable}} </td> -->
          <td style="font-size:12px;">{{total>0?row.Arrears:row.ReceivedMoney}} </td>
        </tr>
      </tbody>
      <tfoot>
      <tr>
        <th colspan="2" style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">合计人民币(大写):</th>
        <th colspan="5" style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">{{this.total>0?this.totalCnTw:this.butottw}}</th>
        <th style="border-bottom:2px solid #000080;border-top:2px solid #000080; text-align:left;">￥:{{this.total>0?this.total:this.butot}}元</th>
      </tr>
      </tfoot>
    </table>
    <div>
      <span style="font-size:12px;">说明：{{remark}}</span>
      <br />
      <br/>
      <span style="font-size:12px;">合并单元包括：{{this.danlenght}}个（{{this.dantext}}）</span>
      <br/>
      <span v-html="commonService.remaks" style="font-size:12px;">
          </span>
    </div>
  </div>

</div>
</template>
<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import commonService from '@/static/commonService';

export default {
  data(){
    return{
      date: dayjs().format('YYYY-MM'),
      list: [],
      remark: '',
      item: [],
      buildName:'',
      userName: '',
      total: 0,
      totalCnTw: '',
      butot:0,
      butottw:'',
      area: '',
      options: [],
      value: [],
      isshow:false,
      unitCode:"",
      commonService: {},
      zrow:0,
      qirow:0,
      danlenght:0,
      dantext:''
    }
  },
  watch:{
    date(){
      this.getlist()
      this.getbianm()
    }
  },
  methods:{
    getSelected(value){
      this.unitCode = value.join(',');
      this.getlist()
    },
    getlist() {
      // 解析年月
      let year = this.date.split('-')[0]
      let month = this.date.split('-')[1]
      let unitCode = this.unitCode

      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/rent`, {
        year, month,unitCode,parkId: this.currentParkId,
      },{
        headers: { token: this.token },
      }).then((respon) => {
        const res = respon.data;
        if(res.resCode === '10000') {
          this.list = res.resData;
          let zcont = 0;
          var arr = []
          for (let i in res.resData) {
              arr.push(res.resData[i]); //属性
          }

          for(var s=0;s<arr.length;s++){
              for(var g = 0;g<arr[s].length;g++){
                  // console.log(arr[s][g].Arrears);
                zcont += parseInt(arr[s][g].Arrears*100000000000000)/100000000000000;
              }
          }
          this.zrow = zcont.toFixed(2);
        }
      });
    },
    getarrears() {
      this.$http.post(`${this.URL_PREFIX}/app/get/user/arrears`, {
        parkId: this.currentParkId,
      },{
        headers: { token: this.token },
      }).then((respon) => {
        const res = respon.data;
        if(res.resCode === '10000') {
          console.log(res.resData.total);
          this.qirow = res.resData.total.toFixed(2);
        }
      });
    },
    getbianm(){
      this.$http.post(`${this.URL_PREFIX}/app/get/user/info/detail`, {},{
        headers: { token: this.token },
      }).then((respon) => {
        const res = respon.data;
        if(res.resCode === '10000') {
          if(res.resData.unitCode){
            this.isshow = true;
            this.options = [];
            const leng = res.resData.unitCode.split(",").length;
            for(var i = 0; i < leng; i++){
                this.options.push({
                  value: res.resData.unitCode.split(",")[i],
                  label: res.resData.unitCode.split(",")[i]
                });
            }
          } 
        }else if(res.resCode === '10004'){
          this.$router.push({ path: '/navigator/auth/login' });
        }
      });
    },
    getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) && index > 5) {
            sums[index] = values.reduce((prev, curr) => {
              curr = Number(curr);
              prev = Number(prev);
              if (!isNaN(curr)) {
                return (Math.round((prev + curr) * 100) / 100).toFixed(2);
              } else {
                return (Math.round(prev * 100) / 100).toFixed(2);
              }
            }, 0);
            sums[index] += ' 元';
          } else {
            sums[index] = '';
          }
        });

        return sums;
      },
    doFormatDate(param) {
      return this.date;
    },
    printContent(id){
      let newContent = document.getElementById(id).innerHTML;
      let oldContent = document.body.innerHTML;
      document.body.innerHTML = newContent;
      window.print();
      document.body.innerHTML = oldContent;
      window.location.reload();
    },
    splitUtilty(str, key, index) {
      if (str !== undefined) {
        // console.log(str.replace('(', '').replace('))', '').replace('=', '-').replace('×', '-').replace('00000000','').split('-'))
        let price = str.replace('(', '').replace('))', '').replace('=', '-').replace('×', '-').replace('00000000','').split('-')[index]
        if (index === 3) {
          return Math.round(price*10000)/10000 + '元/度'
        } else {
          return Math.round(price*10000)/10000
        }
      } else {
        return '-'
      }
    },
    setItem(index) {
      this.remark = '';
      this.total = 0;
      this.butot = 0;
      let leng = this.list[index].length
      if (leng > 0) {
        this.userName = this.list[index][0]['UserName']
        this.area = this.list[index][0]['Area']
        this.buildName = this.list[index][0]['BuildName'] + this.list[index][0]['HouseName'] + '(' + this.list[index][0]['UnitCode'] + ')'
        let total = 0
        let butot = 0
        this.list[index].forEach((v, i)=>{
          total += parseInt(v.Arrears*10000000000000000)/10000000000000000
          butot += parseInt(v.ReceivedMoney*10000000000000000)/10000000000000000
          if(v.Remark !== undefined){
            this.remark += v.Remark + '；';
          }
        })
        this.total = total.toFixed(2);
        this.butot = butot.toFixed(2);
        this.totalCnTw = this.smalltoBIG(this.total)
        this.butottw = this.smalltoBIG(this.butot)
      }
      this.item = this.list[index]

      var _this = this
      setTimeout(function () {
        _this.printContent('PrintContent')
      }, 500);

    },
    setItem2() {
      this.remark = '';
      this.total = 0;
      this.butot = 0;
      var arr = [];
      for (let i in this.list) {
          arr.push(this.list[i]); //属性
      }
      var popr = []
      // var 
      for (let j in arr) {
        popr = popr.concat(arr[j]);
        if(arr[j][0]){
          this.danlenght+=1;
          this.dantext += arr[j][0].UnitCode+',';
          this.userName = arr[j][0]['UserName'];
          this.area = arr[j][0]['Area'];
          this.buildName = arr[j][0]['BuildName'] + arr[j][0]['HouseName'] + '(' + arr[j][0]['UnitCode'] + ')'
        }
      }
      let total = 0
      let butot = 0
      popr.forEach((v, i)=>{
        total += parseInt(v.Arrears*100000000000000)/100000000000000
        butot += parseInt(v.ReceivedMoney*100000000000000)/100000000000000
        if(v.Remark !== undefined){
          this.remark += v.Remark + '；';
        }
      })
      // this.danlenght = arr.length;
    
      var allArr = [];//新数组
      var newarr = [];//重复数组
      for(var i=0;i<popr.length;i++){
      　　var flag = true;
      　　for(var j=0;j<allArr.length;j++){
      　　　　if(popr[i].ChargingItem == allArr[j].ChargingItem&&popr[i].ChargingItem!='水费'){
      　　　　　　flag = false;
                newarr.push(popr[i]);
      　　　　};
      　　}; 
      　　if(flag){
      　　　　allArr.push(popr[i]);
      　　};
      };
      
      // for(var k=0;k<allArr.length;k++){
      //     if(allArr[k].ChargingItem != newarr[k].ChargingItem){
      //         allArr[k].Arrears=parseInt(allArr[k].Arrears*100000000)/100000000+parseInt(newarr[k].Arrears*100000000)/100000000;
      //     }
      // }
      // console.log(allArr);
      // this.totalCnTw = this.smalltoBIG(this.zrow)
      this.total = total.toFixed(2);
      this.butot = butot.toFixed(2);
      this.totalCnTw = this.smalltoBIG(this.total)
      this.butottw = this.smalltoBIG(this.butot)
      this.item = popr
      var _this = this
      setTimeout(function () {
        _this.printContent('ZContent')
      }, 500);

    },
    smalltoBIG(n) { /** 数字金额大写转换(可以处理整数,小数,负数) */
      var fraction = ['角', '分'];
      var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
      var unit = [ ['元', '万', '亿'], ['', '拾', '佰', '仟']  ];
      var head = n < 0? '欠': '';
      n = Math.abs(n);

      var s = '';

      for (var i = 0; i < fraction.length; i++)
      {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
      }
      s = s || '整';
      n = Math.floor(n);

      for (var i = 0; i < unit[0].length && n > 0; i++)
      {
        var p = '';
        for (var j = 0; j < unit[1].length && n > 0; j++)
        {
          p = digit[n % 10] + unit[1][j] + p;
          n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零')  + unit[0][i] + s;
      }
      return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
    }

},
  mounted() {
    this.getlist();
    this.getarrears();
    this.getbianm();
    this.commonService = commonService[process.env.commonServiceConfKey][this.currentParkId];
  },
  computed: {
    ...mapGetters(['currentParkId', 'token']),
  },
}
</script>
<style lang="scss" scoped>
.Orders{
  .select{
    width: 940px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 20px;
  }
  .ajie_table{
    padding: 20px;
    font-size: 12px;
    background-color: #fff;
    .el-table{
      font-size: 12px;
      .el-button{
        color: #333;
        font-weight: normal;
        &.title {
          width: 400px;
        }
        &:hover{
          text-decoration: underline;
        }
      }
    }
  }
}
.fy{
  text-align: center;
  margin-top: 76px;
}
  .box-card {
    margin-top: 20px;
  }
  .gongz{
    position: absolute;
    top: 100px;
    left: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/navigator/personal/components/info/Property.vue